<template>
  <v-container
    id="fuel-operations-view"
    fluid
    tag="section"
  >
    <cumulus-edit-dialog
      ref="editElement"
      v-model="dialogEdit"
      icon="$edit"
      :title="'fuel_operation'"
      :new-item="new_item"
      can-delete
      @save="saveElement"
      @remove="removeElement"
      @new="showDialogEdit"
      @escape="closeDialogEdit"
    >
      <template v-slot:editform>
        <edit-fuel-operation
          :fuel-operation="edited_item"
        />
      </template>
    </cumulus-edit-dialog>

    <material-card
      icon="$fuel"
      icon-small
      color="accent"
      :title="page_title"
    >
      <template v-slot:title2>
        <tooltip-btn
          icon="$back"
          tooltip="back"
          @click="back"
        />
      </template>
      <v-card-title>
        <v-btn
          v-shortkey.once="['f2']"
          color="primary"
          class="ma-2"
          @shortkey="showDialogEdit()"
          @click="showDialogEdit()"
        >
          {{ $t('new_item',{ item: $t('fuel_operation') }) }}
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="showHeaders"
          :items="items"
          :loading="loading"
          :loading-text="$t('loading')"
          :options.sync="options"
          :server-items-length="total"
          :footer-props="footerProps"
          :item-class="rowClasses"
        >
          <template v-slot:item.date="{item}">
            {{ item.date | dateTimeFormat }}
          </template>
          <template v-slot:item.fuel_type="{item}">
            {{ $t(item.fuel_type) }}
          </template>
          <template #item.actions="{item}">
            <tooltip-btn
              v-for="(action, i) in actions"
              :key="i"
              :show="!action.disable"
              :color="action.color"
              :icon="action.icon"
              :tooltip="action.tooltip"
              @click="action.func(item)"
            />
          </template>
        </v-data-table>
      </v-card-text>
    </material-card>
  </v-container>
</template>

<script>
  import { call, get, sync } from 'vuex-pathify'
  import { format, addDays } from 'date-fns'
  import CumulusEditDialog from '@/components/EditDialog.vue'
  import EditFuelOperation from '@/layouts/default/edit/FuelOperation.vue'

  export default {
    name: 'FuelOperationsView',
    components: { EditFuelOperation, CumulusEditDialog },
    data () {
      return {
        dialogEdit: false,
        edited_index: -1,
        edited_item: {},
        items: [],
        headerMaps: {
          plane: ['date', 'fuel_type', 'operation', 'start', 'end', 'quantity', 'actions'],
        },
        footerProps: {
          itemsPerPageOptions: [10, 20, 25, 50, 100],
        },
        total: 0,
        timer: null,
        sourceType: null,
        sourceId: null,
        source_name: '',
        prevRoute: '',
        history_list: [],
      }
    },
    computed: {
      loading: get('app/loading'),
      profile: get('auth/profile'),
      options: sync('fuelOperation/options'),
      search: sync('fuelOperation/search'),
      headers () {
        return [
          {
            align: 'start',
            text: this.$t('fields.date'),
            value: 'date',
          },
          {
            text: this.$t('fields.fuel_type'),
            value: 'fuel_type',
          },
          {
            text: this.$t('fields.fuel_operation'),
            value: 'operation',
          },
          {
            text: this.$t('fields.fuel_start'),
            value: 'start',
          },
          {
            text: this.$t('fields.fuel_end'),
            value: 'end',
            sortable: false,
          },
          {
            text: this.$t('fields.fuel_quantity'),
            value: 'quantity',
            sortable: false,
          },
          {
            // text: this.$t('actions'),
            value: 'actions',
            sortable: false,
            align: 'right',
          },
        ]
      },
      showHeaders () { return this.sourceType ? this.headers.filter(e => this.headerMaps[this.sourceType].includes(e.value)) : [] },
      actions () {
        return [
          { color: 'success', icon: '$edit', tooltip: 'tooltip_edit', func: this.showDialogEdit },
        ]
      },
      page_title () {
        if (this.sourceType === 'plane') {
          return `${this.$t('refueling_operations')} - ${this.source_name}`
        } else {
          return this.$t('refueling_operations')
        }
      },
      new_item () { return this.edited_index === -1 },
    },
    watch: {
      search: {
        handler () {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            this.options.page = 1
            this.load()
          }, 800)
        },
        deep: true,
      },
      options: {
        handler () {
          this.load()
        },
        deep: true,
      },
    },
    mounted () {
      this.sourceType = this.$route.params.sourcetype ?? 'user'
      this.sourceId = this.sourceType === 'organization' ? this.profile.organization.id : parseInt(this.$route.params.id ?? this.profile.user_id)
      this.getName()
      // this.showHeaders = this.headers.filter(e => this.headerMaps[this.sourceType].includes(e.value))
      this.load()
    },
    methods: {
      getList: call('fuelOperation/search'),
      elementUpdate: call('fuelOperation/update'),
      elementInsert: call('fuelOperation/insert'),
      elementDelete: call('fuelOperation/delete'),
      getReport: call('action/getReport'),
      fetchDatasource: call('datasource/fetchDatasource'),
      async load () {
        try {
          await this.getList({
            sourceId: this.sourceId,
            sourceType: this.sourceType,
          }).then(response => {
            this.items = response.data
            this.total = response.total
          }).catch(e => {
            console.log(e)
          })
        } catch (e) {
        }
      },
      showDialogEdit (item) {
        if (!item) {
          this.edited_index = -1
          this.edited_item = {
            date: null,
            vehicle_type: this.sourceType,
            vehicle_id: this.sourceId,
            flight_id: null,
            fuel_type: 'benzine',
            operation: 'be',
            start: null,
            end: null,
            quantity: null,
          }
        } else {
          this.edited_index = this.items.indexOf(item)
          this.edited_item = Object.assign({}, item)
        }
        this.dialogEdit = true
      },
      closeDialogEdit () {
        this.dialogEdit = false
        this.edited_item = {}
        this.edited_index = -1
      },
      async saveElement () {
        if (this.edited_index > -1) {
          await this.elementUpdate(
            this.edited_item,
          ).then(response => {
            Object.assign(this.items[this.edited_index], response)
            this.closeDialogEdit()
          }).catch(e => {
            this.$refs.editElement.setErrors(e)
          })
        } else {
          await this.elementInsert(
            this.edited_item,
          ).then(response => {
            this.items.push(response)
            this.total += 1
            this.closeDialogEdit()
          }).catch(e => {
            this.$refs.editElement.setErrors(e)
          })
        }
      },
      async removeElement () {
        await this.elementDelete(
          { id: this.edited_item.id },
        ).then(response => {
          this.items.splice(this.edited_index, 1)
          this.total -= 1
          this.closeDialogEdit()
        }).catch(e => {
          this.$refs.editElement.setErrors(e)
          console.log(e)
        })
      },
      getName () {
        if (this.sourceType === 'plane') {
          this.fetchDatasource({ sourceType: 'planes-all' }).then(response => {
            response = response.filter(f => f.id === this.sourceId)
            this.source_name = response[0].name
          })
        } else if (this.sourceType === 'organization') {
          this.source_name = this.profile.organization.name
        } else if (this.sourceType === 'component') {
          this.source_name = this.$t('component')
        } else if (this.sourceType === 'training') {
          this.source_name = this.$t('training')
        } else if (this.sourceType === 'user_training') {
          this.source_name = this.$t('training')
        } else {
          this.fetchDatasource({ sourceType: 'users' }).then(response => {
            response = response.filter(f => f.id === this.sourceId)
            this.source_name = response[0].name
          })
        }
      },
      rowClasses (item) {
        if (item.expiration_date < format(new Date(), 'yyyy-MM-dd')) {
          // console.log(item.enable)
          return 'red lighten-5'
        }
        if (item.expiration_date < format(addDays(new Date(), 15), 'yyyy-MM-dd')) {
          // console.log(item.enable)
          return 'yellow lighten-5'
        }
      },
      back () {
        switch (this.sourceType) {
          case 'user' :
            this.$router.push('/users/').catch(() => {})
            break
          case 'component' :
            this.$router.push('/components/').catch(() => {})
            break
          case 'trainings' :
            this.$router.push('/settings/trainings/').catch(() => {})
            break
          case 'user_trainings' :
            this.$router.push('/training/planning/').catch(() => {})
            break
          default :
            this.$router.push(this.prevRoute.path).catch(() => {})
        }
      },
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.prevRoute = from
      })
    },
  }

</script>
